import { render, staticRenderFns } from "./ReferralFull.vue?vue&type=template&id=0cdfb5cb"
import script from "./ReferralFull.vue?vue&type=script&lang=js"
export * from "./ReferralFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports